import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewPaginationComponent } from './new-pagination.component';



@NgModule({
  declarations: [
    NewPaginationComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NewPaginationComponent
  ]
})
export class NewPaginationModule { }
